import { Injectable } from '@angular/core';
import { AppMetadataHandler } from 'app'
import { Subject, zip, BehaviorSubject } from 'rxjs'
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataTransformService {

  auditLogOldDOName = null;
  auditLogNewDOName = null;
  auditLogOld=null;
  auditLogNew=null; 
  documentPreview = {}

  isSidebarCollapsed:boolean = false
  enableFloatingSplitScreen:boolean = false
  fraudRisk : string = null;
  fraudScore : number = 0;
  propensityRisk : number = 0;
  riskRecommendation : string = null;
  selectedProductType = null;
  docuPanelOpen = false;
  enablePersonalizedInboxModal : boolean = false
  riskSummarizationLoader : boolean = false;

  public activeTransactionStore = {
    components: {
      "MulticaptureBankDetailsComponent": null
    },
    refreshToggle : {
      
    }
  };
  workQueueResponse = []
  disabledProcessType:any=false

  gridTransactionState
  constructor(public appMetadataHandler: AppMetadataHandler) { }

  barCodeNum = "12345";
  labTestData = {}
  fetchList = [];
  policySearchResult: any=  [];
  dataset: any = [];
  riskSummary = null;
  riskSummarizationResponse = null;
  initializeTransactionPageDataStateMap(mapperTransactionState, configData) {
    let listOfAllChildren = this.getListOfChildrenForCurrentState(mapperTransactionState, configData);
    let trasactionPageDataStateMap = {}
    trasactionPageDataStateMap[mapperTransactionState] = {}
    trasactionPageDataStateMap[mapperTransactionState]["components"] = {}
    let components = {}
    if (listOfAllChildren && Array.isArray(listOfAllChildren) && listOfAllChildren.length > 0) {
      listOfAllChildren.forEach(child => {
        components[child] = new Subject()
      })
    }
    trasactionPageDataStateMap[mapperTransactionState]["components"] = components

    return trasactionPageDataStateMap
  }

  getListOfChildrenForCurrentState(mapperTransactionState: any, configData: any) {
    let defaultChildrenComponents = configData.StateToChildComponentMapper.allStates;
    let specificChildrenComponents = configData.StateToChildComponentMapper[mapperTransactionState];
    let listOfAllChildren = [...defaultChildrenComponents, ...specificChildrenComponents];
    return listOfAllChildren
  }

  getChildrenSubscriberDataPipe(trasactionPageDataStateMap, mapperTransactionState) {
    let childrenSubscribers$ = []
    if (mapperTransactionState) {
      let components = trasactionPageDataStateMap[mapperTransactionState].components
      for (const key in components) {
        if (components.hasOwnProperty(key)) {
          childrenSubscribers$.push(components[key]);
        }
      }
    }

    if (childrenSubscribers$.length == Object.keys(trasactionPageDataStateMap[mapperTransactionState].components).length)
      return childrenSubscribers$
    else
      throw new Error("Number of Subject Mappers Do not Match Number of childrenSubscribers")
  }

  getChildrenNumber(trasactionPageDataStateMap, mapperTransactionState) {
    let count = null
    if (trasactionPageDataStateMap &&
      trasactionPageDataStateMap[mapperTransactionState] &&
      trasactionPageDataStateMap[mapperTransactionState]['components'] &&
      trasactionPageDataStateMap[mapperTransactionState]['components']
    ) {
      let c = Object.keys(trasactionPageDataStateMap[mapperTransactionState]['components'])
      count = c.length
    }

    console.log("count", count)
    return count
  }

  emitterHistory = {}
  childrenDataPipeSubscription$
  initializeChildSubscribers(trasactionPageDataStateMap, mapperTransactionState) {
    this.emitterHistory = {};
    var childResponsesSubject = new BehaviorSubject(null);
    let childrenDataPipe = this.getChildrenSubscriberDataPipe(trasactionPageDataStateMap, mapperTransactionState)
    if (childrenDataPipe.length === this.getChildrenNumber(trasactionPageDataStateMap, mapperTransactionState)) {
      if (this.childrenDataPipeSubscription$ != null) this.childrenDataPipeSubscription$.unsubscribe()
      this.childrenDataPipeSubscription$ = zip(...childrenDataPipe).subscribe(responses => {
        let emitterLength = Object.keys(this.emitterHistory).length
        let numberOfChildren = this.getChildrenNumber(trasactionPageDataStateMap, mapperTransactionState)
        console.log((Object.keys(this.emitterHistory).length + " count of object"));
        if (this.appMetadataHandler.featureFlags.transformValidatorAfterZip &&
          emitterLength == numberOfChildren)
          childResponsesSubject.next(responses)
        else {
          if (!environment.production) {
            throw "Missing Subject for a component that's emitting data. Check transactionPageDataStateMap or _BaseEmitterHandler.";

          }
        }
      })
    }
    else {
      throw "Component Emitters Mismatch";

    }

    return childResponsesSubject
  }

  removedPolicies = [];
  removedPolicyRegistry(removedPolicyList){
    this.removedPolicies.push(removedPolicyList)
    console.log("removed policy list: ", this.removedPolicies)
  }
  removedClient = [];
  removedSelectedClient(removedClientData){
  this.removedClient.push(removedClientData)
  };
  removedPayeeList = [];
  removedPayee(removedPayee){
  this.removedPayeeList.push(removedPayee);
  }

}
